/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Agents_organization$ref = any;
export type AgentsRendererQueryVariables = {|
  organizationSlug: string
|};
export type AgentsRendererQueryResponse = {|
  +organization: ?{|
    +$fragmentRefs: Agents_organization$ref
  |}
|};
export type AgentsRendererQuery = {|
  variables: AgentsRendererQueryVariables,
  response: AgentsRendererQueryResponse,
|};
*/


/*
query AgentsRendererQuery(
  $organizationSlug: ID!
) {
  organization(slug: $organizationSlug) {
    ...Agents_organization
    id
  }
}

fragment Agents_organization on Organization {
  id
  uuid
  slug
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "organizationSlug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Agents_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91007c034aff18b9310d994f934bde65",
    "id": null,
    "metadata": {},
    "name": "AgentsRendererQuery",
    "operationKind": "query",
    "text": "query AgentsRendererQuery(\n  $organizationSlug: ID!\n) {\n  organization(slug: $organizationSlug) {\n    ...Agents_organization\n    id\n  }\n}\n\nfragment Agents_organization on Organization {\n  id\n  uuid\n  slug\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a502c899d88c88d4ac2ab1d9a15296bd';

module.exports = node;
